import _ from 'lodash';
import { orderObjectBy } from 'Utils/filters';
import template from './flowmeter.html';


export default {
  name: 'productionFlowmeter',
  template,
  controller: FlowMeterController,
  controllerAs: 'ProductionFlowmeterCtrl',
  bindings: {
    options: '<',
    queryParams: '<'
  }
};

/* @ngInject */
function FlowMeterController($log, ReportsService, ModalService, growl) {
  const vm = this;
  // public variables
  vm.enableExport = false;
  vm.productionReportDatas = null; // set on generate report
  vm.cumulativeData = null;
  vm.arrageByCumulative = false;
  vm.neverRan = true;

  // private var
  const equipmentToPoints = {};

  // public functions
  vm.$onInit = initialize;
  vm.generateProductionReport = generateProductionReport;
  vm.tanksEmpty = tanksEmpty;
  vm.setToIndividual = setToIndividual;
  vm.setToCumulative = setToCumulative;
  vm.invalidDate = ReportsService.invalidDate;
  vm.lengthOf = ReportsService.lengthOf;
  vm.deepLink = ReportsService.deepLink;
  vm.exportData = ReportsService.exportData;

  vm.noResults = noResults;
  vm.openCopyReportLink = ModalService.openCopyReportLink;

  function initialize() {
    vm.options.tanks = [];
    vm.listOfTanks = [];

    loadFlowMeters();
  }

  function tanksEmpty() {
    // only one tank can currently be selected
    // and the 'tanks' property holds the string id
    // if no tank is selected, it will be the empty string
    return _.get(vm.options, 'tanks.length');
  }

  function loadFlowMeters() {
    return ReportsService.getListOfFlowMeters()
      .then((success) => {
        let tank;
        vm.listOfTanks = _.filter(success, equipment =>
          _.has(equipment, ['settings', 'flowMeterProductionReport', 'enabled']) &&
            equipment.settings.flowMeterProductionReport.enabled
        );
        if (vm.queryParams && vm.queryParams.tanks) {
          tank = _.find(vm.listOfTanks, ['id', vm.queryParams.tanks]);
          if (tank) {
            vm.options.tanks.push(tank);
          }
        }

        // Build out equipmentToPoints
        _.forEach(vm.listOfTanks, (tk) => {
          if (_.has(tk, ['settings', 'flowMeterProductionReport', 'cumulativeStaticPoints']) &&
              tk.settings.flowMeterProductionReport.enabled &&
            _.size(tk.settings.flowMeterProductionReport.cumulativeStaticPoints) > 0) {
            equipmentToPoints[tk.id] = {};
            const tankPoint = equipmentToPoints[tk.id];
            _.forEach(
              tk.settings.flowMeterProductionReport.cumulativeStaticPoints,
              (points, key) => {
                tankPoint[key] = _.reduce(
                  points,
                  (memo, possibleName) => [...memo, possibleName],
                  tankPoint[key] || []
                );
              });
          }
        });
        if (tank) {
          generateProductionReport(true);
        }
      });
  }

  // TODO: Break this up
  function generateProductionReport(first) {
    if (vm.options.tanks.length <= 0 && !first) {
      growl.info('Equipment not selected.', {
        ttl: 3000
      });
      return null;
    }
    vm.isLoading = true;
    const tankContractHours = {};
    const equipmentToPossibleDataPoints = {};
    _.forEach(vm.options.tanks, (id) => {
      // get contract hours
      const tank = _.find(vm.listOfTanks, ['id', id]);
      let contractHour = 11; // default contractHour
      if (_.has(tank, ['settings', 'flowMeterProductionReport', 'contractHourReport'])) {
        contractHour = tank.settings.flowMeterProductionReport.contractHourReport;
      }
      tankContractHours[id] = contractHour;

      // get possible data points
      equipmentToPossibleDataPoints[id] = equipmentToPoints[id];
    });

    const dayAfterStartDay = addSubtractDays(vm.options.date.start, 1);
    const dayAfterEndDay = addSubtractDays(vm.options.date.end, 1);

    return ReportsService.getTotalFlowProductionReportData(
      tankContractHours,
      dayAfterStartDay.valueOf(),
      dayAfterEndDay.valueOf(),
      equipmentToPossibleDataPoints
    ).then((success) => {
      vm.neverRan = false;
      vm.cumulativeData = [];
      vm.productionReportDatas = {};

      // individual report//

      // create structure
      _.forEach(success.data, (event) => {
        if (event.equipmentId && event.yesterdayVolume && event.date) {
          if (!vm.productionReportDatas[event.equipmentId]) {
            const equipment = _.find(vm.listOfTanks, ['id', event.equipmentId]);

            const equipmentName = equipment ? equipment.name : event.equipmentId;

            vm.productionReportDatas[event.equipmentId] = {
              equipmentName,
              data: []
            };
          }

          vm.productionReportDatas[event.equipmentId].data.push({
            equipmentId: event.equipmentId,
            equipmentName: vm.productionReportDatas[event.equipmentId].equipmentName,
            yesterdayVolume: event.yesterdayVolume,
            date: new Date(event.date)
          });
        } else {
          $log.error('Event has incomplete data, skipping.', event);
        }
      });

      // sort and calculate cumulative for individual tanks
      _.forEach(vm.productionReportDatas, (equipmentEvents) => {
        equipmentEvents.data.sort((event1, event2) => event1.date - event2.date);
        let cumulativeYesterdayVolume = 0;
        _.forEach(equipmentEvents.data, (event) => {
          // eslint-disable-next-line new-cap
          cumulativeYesterdayVolume = _.toString(Big(cumulativeYesterdayVolume)
            .plus(event.yesterdayVolume));
          event.cumulativeYesterdayVolume = parseFloat(cumulativeYesterdayVolume);
        });
      });

      // cumulative equipment//
      // group
      const cumulativeDateGrouped = {};
      _.forEach(_.cloneDeep(vm.productionReportDatas), (equipment) => {
        _.forEach(equipment.data, (event) => {
          const midNightOfEvent = new Date(event.date);
          midNightOfEvent.setHours(0, 0, 0, 0);
          if (!cumulativeDateGrouped[midNightOfEvent]) {
            cumulativeDateGrouped[midNightOfEvent] = [];
          }
          cumulativeDateGrouped[midNightOfEvent].push(event);
        });
      });

      // Order a separate list for one ng-repeat
      vm.orderedProdReportData = orderObjectBy(vm.productionReportDatas, 'equipmentName');


      // combine
      vm.cumulativeData = _.map(cumulativeDateGrouped, (group) => {
        let yesterdayVolumeForDate = 0;
        _.forEach(group, (event) => {
          yesterdayVolumeForDate =
              // eslint-disable-next-line new-cap
              parseFloat(_.toString(Big(yesterdayVolumeForDate).plus(event.yesterdayVolume)));
        });
        return {
          date: group[0].date,
          yesterdayVolume: yesterdayVolumeForDate
        };
      });

      vm.cumulativeData.sort((event1, event2) => event1.date - event2.date);

      // overwrite cumulativeYesterdayVolume for each event
      let cumulativeYesterdayVolume = 0;
      _.forEach(vm.cumulativeData, (event) => {
        // eslint-disable-next-line new-cap
        cumulativeYesterdayVolume = _.toString(Big(cumulativeYesterdayVolume).plus(event.yesterdayVolume));
        event.cumulativeYesterdayVolume = parseFloat(cumulativeYesterdayVolume);
      });

      vm.enableExport = !noResults();
      vm.isLoading = false;
    });
  }

  /*
     * Add or subtract days to date object
     * @param {Date} date date to add days to
     * @param {number} number of day to alter.  Can be positive or negative.
     */
  function addSubtractDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function setToIndividual() {
    vm.arrageByCumulative = false;
  }

  function setToCumulative() {
    vm.arrageByCumulative = true;
  }

  function noResults() {
    return _.isEmpty(vm.cumulativeData);
  }
}
